import { render, staticRenderFns } from "./iconAddToCart.vue?vue&type=template&id=521bcf5f"
import script from "./iconAddToCart.vue?vue&type=script&lang=js"
export * from "./iconAddToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports